import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { SecretsManagerService } from '../../service';

export type RotationEnabledConfig = typeof RotationEnabledConfig._.Config;

export const RotationEnabledConfig = IntegrationConfig.make({
  service: SecretsManagerService,
  name: Integration_Handler_Names_Enum.RotationEnabled,
  configSchema: z.object({
    maxRotationFrequencyDays: z.number().min(1).max(365).optional(),
    secretPatternFilter: patternFilterSchema.optional(),
  }),
});
